import React from "react";
import Tooltip from "@mui/material/Tooltip";
import * as Styles from "../../styles";

interface Props {
  leadId: string;
  leadCorretorId: string;
  leadNome: string;
  onUpdateClick: (leadId: string) => void;
  onMenuClick: (
    event: React.MouseEvent,
    leadId: string,
    leadCorretorId: string,
    leadNome: string
  ) => void;
}

const ArrowRightIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="white"
      d="m16.697 10.058-2.336 2.336L21.95 20l-7.59 7.606 2.337 2.336L26.639 20l-9.942-9.942Z"
    />
  </svg>
);

export const ActionsCell: React.FC<Props> = ({
  leadId,
  leadCorretorId,
  leadNome,
  onUpdateClick,
  onMenuClick,
}) => (
  <Styles.SecondFixedTd align="center">
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",
      }}
    >
      <Styles.UpdateButton onClick={() => onUpdateClick(leadId)}>
        Atualizar
        <ArrowRightIcon />
      </Styles.UpdateButton>
      <Styles.OnClick
        onClick={(event) =>
          onMenuClick(event as any, leadId, leadCorretorId, leadNome)
        }
      >
        <Tooltip followCursor title="Outras ações" placement="top">
          <i
            className="las la-ellipsis-v"
            style={{ fontSize: "1.4em", marginTop: 2 }}
          />
        </Tooltip>
      </Styles.OnClick>
    </div>
  </Styles.SecondFixedTd>
);
